import { Controller, useFormContext } from "react-hook-form";
import { Dropdown } from "primereact/dropdown";

export const CustomSelect = ({ name, options, placeholder, rules }: any) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <Dropdown
          {...field}
          className="w-full"
          options={options}
          placeholder={placeholder}
        />
      )}
    />
  );
};
